import { enableProdMode, provideZoneChangeDetection, LOCALE_ID, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';


import { environment } from './environments/environment';
import { services } from './app/services';
import { PreloadAllModulesWithDelay } from './app/preload';
import { VisitorService } from './app/visitor/visitor.service';
import { CompanyService } from './app/visitor/company.service';
import { SchoolService } from './app/visitor/school.service';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './app/core/core.module';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from './app/shared/shared.module';
import { AuthenticationModule } from '@mango/authentication';
import { routing } from './app/app.routing';
import { MatStepperModule } from '@angular/material/stepper';
import { ReactiveFormsModule } from '@angular/forms';
import { directives } from './app/directives';
import { registerLocaleData } from '@angular/common';
import { AppComponent } from './app/app.component';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { DateAdapter } from '@angular/material/core';
import { DutchDateAdapter } from '@mango/core';
import { MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS } from '@angular/material/slide-toggle';
import { bootstrapApplication } from '@angular/platform-browser';
import './app/core/utils/mango-paged-data-source-patch';
// Dutch day and month names and Monday as first day of the week in Mango's (moment based) date pickers
import 'moment/locale/nl';

import { localeNlAngular12 } from './app/core/utils/angular12-dutch-locale';
registerLocaleData(localeNlAngular12);



if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(MatSnackBarModule, MatButtonModule, BrowserAnimationsModule, CoreModule, MatIconModule, SharedModule, AuthenticationModule.forRoot(), routing, MatStepperModule, ReactiveFormsModule, directives),
        provideZoneChangeDetection(),
        // Mango's date and datetime pickers work with moment: its own module imports MatNativeDateModule, which provides the
        // native Date adapter after (and instead of) CoreModule's, so the pickers broke on the first click. Providers listed here win.
        { provide: DateAdapter, useClass: DutchDateAdapter },
        { provide: LOCALE_ID, useValue: "nl-NL" },
        // All form fields outlined (Mango 22's own fields are outlined too)
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
        // Mango 22 translates the paginator texts to Dutch; the Angular 12 app showed Angular's English ones
        { provide: MatPaginatorIntl, useClass: MatPaginatorIntl },
        // Angular 12 toggles had no check/minus icon in the handle
        { provide: MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS, useValue: { hideIcon: true } },
        services,
        PreloadAllModulesWithDelay,
        VisitorService,
        CompanyService,
        SchoolService
    ]
})
  .catch(err => console.log(err));
